<template>
    <div class="w-100 h-100">
        <ul class="list-unstyled d-flex flex-column justify-space-around h-100">
            <li class="d-inline-block active" @click="[makeActive('allApplicants')]"
                :style="[listStatus.allApplicants ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.5 1C17.5717 1 16.6815 1.36875 16.0251 2.02513C15.3687 2.6815 15 3.57174 15 4.5V18.5C15 19.4283 15.3687 20.3185 16.0251 20.9749C16.6815 21.6313 17.5717 22 18.5 22C19.4283 22 20.3185 21.6313 20.9749 20.9749C21.6313 20.3185 22 19.4283 22 18.5C22 17.5717 21.6313 16.6815 20.9749 16.0251C20.3185 15.3687 19.4283 15 18.5 15H4.5C3.57174 15 2.6815 15.3687 2.02513 16.0251C1.36875 16.6815 1 17.5717 1 18.5C1 19.4283 1.36875 20.3185 2.02513 20.9749C2.6815 21.6313 3.57174 22 4.5 22C5.42826 22 6.3185 21.6313 6.97487 20.9749C7.63125 20.3185 8 19.4283 8 18.5V4.5C8 3.57174 7.63125 2.6815 6.97487 2.02513C6.3185 1.36875 5.42826 1 4.5 1C3.57174 1 2.6815 1.36875 2.02513 2.02513C1.36875 2.6815 1 3.57174 1 4.5C1 5.42826 1.36875 6.3185 2.02513 6.97487C2.6815 7.63125 3.57174 8 4.5 8H18.5C19.4283 8 20.3185 7.63125 20.9749 6.97487C21.6313 6.3185 22 5.42826 22 4.5C22 3.57174 21.6313 2.6815 20.9749 2.02513C20.3185 1.36875 19.4283 1 18.5 1Z"
                          :stroke="listStatus.allApplicants ? '#431288' : '#2B1C1C'" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span :style="[listStatus.allApplicants ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">All Applicants</span>
            </li>

            <li class="d-inline-block" @click="[makeActive('awaitingInterview')]"
                :style="[listStatus.awaitingInterview ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">


                <svg width="15" height="15" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.6667 1H3.33333C2.04467 1 1 2.04467 1 3.33333V19.6667C1 20.9553 2.04467 22 3.33333 22H19.6667C20.9553 22 22 20.9553 22 19.6667V3.33333C22 2.04467 20.9553 1 19.6667 1Z"
                          :stroke="listStatus.awaitingInterview ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 8L15 15" :stroke="listStatus.awaitingInterview ? '#431288' : '#2B1C1C'"
                          stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15 8L8 15" :stroke="listStatus.awaitingInterview ? '#431288' : '#2B1C1C'"
                          stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>


                <span :style="[listStatus.awaitingInterview ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Awaiting Interview</span>
            </li>


            <li class="d-inline-block" @click="[makeActive('interviewScheduled')]"
                :style="[listStatus.interviewScheduled ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                          :stroke="listStatus.interviewScheduled ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M12 6V12L16 14" :stroke="listStatus.interviewScheduled ? '#431288' : '#2B1C1C'"
                          stroke-opacity="0.5" stroke-width="2"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span :style="[listStatus.interviewScheduled ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Interview Scheduled</span>
            </li>


            <li class="d-inline-block" @click="[makeActive('interviewing')]"
                :style="[listStatus.interviewing ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.00003 10.9167C0.996018 12.4565 1.35578 13.9755 2.05003 15.35C2.87319 16.997 4.13865 18.3824 5.70467 19.3508C7.27068 20.3193 9.0754 20.8326 10.9167 20.8333C12.4565 20.8374 13.9755 20.4776 15.35 19.7833L22 22L19.7833 15.35C20.4776 13.9755 20.8373 12.4565 20.8333 10.9167C20.8326 9.0754 20.3193 7.27068 19.3508 5.70467C18.3824 4.13865 16.997 2.87319 15.35 2.05003C13.9755 1.35579 12.4565 0.996018 10.9167 1.00003H10.3334C7.90162 1.13419 5.60481 2.16059 3.8827 3.8827C2.16059 5.60481 1.13419 7.90162 1.00003 10.3334V10.9167Z"
                          :stroke="listStatus.interviewing ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span :style="[listStatus.interviewing ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Interviewing</span>
            </li>


            <li class="d-inline-block" @click="[makeActive('interviewed')]"
                :style="[listStatus.interviewed ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.3333 22L9.16667 16.1667L1 22V3.33333C1 2.71449 1.24583 2.121 1.68342 1.68342C2.121 1.24583 2.71449 1 3.33333 1H15C15.6188 1 16.2123 1.24583 16.6499 1.68342C17.0875 2.121 17.3333 2.71449 17.3333 3.33333V22Z"
                          :stroke="listStatus.interviewed ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
                <span :style="[listStatus.interviewed ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Interviewed</span>
            </li>


            <li class="d-inline-block" @click="[makeActive('offeredAdmission')]"
                :style="[listStatus.offeredAdmission ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 19 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 1L10.45 12.55" :stroke="listStatus.offeredAdmission ? '#431288' : '#2B1C1C'"
                          stroke-opacity="1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M22 1L14.65 22L10.45 12.55L1 8.35L22 1Z"
                          :stroke="listStatus.offeredAdmission ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span :style="[listStatus.offeredAdmission ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Offered Admission</span>
            </li>

            <li class="d-inline-block" @click="[makeActive('enrolled')]"
                :style="[listStatus.enrolled ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]">
                <svg width="15" height="15" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 9.16667L11.5 1L22 9.16667V22C22 22.6188 21.7542 23.2123 21.3166 23.6499C20.879 24.0875 20.2855 24.3333 19.6667 24.3333H3.33333C2.71449 24.3333 2.121 24.0875 1.68342 23.6499C1.24583 23.2123 1 22.6188 1 22V9.16667Z"
                          :stroke="listStatus.enrolled ? '#431288' : '#2B1C1C'" stroke-opacity="1"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                  <path d="M8 24.3333V12.6667H15V24.3333"
                        :stroke="listStatus.enrolled ? '#431288' : '#2B1C1C'"
                        stroke-opacity="1" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              <span :style="[listStatus.enrolled ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Enrolled</span>
            </li>


          <li :style="[listStatus.checkedIn ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]"
              class="d-inline-block"
              @click="[makeActive('checkedIn')]">
            <svg fill="none" height="15" viewBox="0 0 23 26" width="15" xmlns="http://www.w3.org/2000/svg">
              <path :stroke="listStatus.checkedIn ? '#431288' : '#2B1C1C'"
                    d="M1 9.16667L11.5 1L22 9.16667V22C22 22.6188 21.7542 23.2123 21.3166 23.6499C20.879 24.0875 20.2855 24.3333 19.6667 24.3333H3.33333C2.71449 24.3333 2.121 24.0875 1.68342 23.6499C1.24583 23.2123 1 22.6188 1 22V9.16667Z"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-opacity="1"
                    stroke-width="2"/>
              <path :stroke="listStatus.checkedIn ? '#431288' : '#2B1C1C'"
                    d="M8 24.3333V12.6667H15V24.3333"
                    stroke-linecap="round" stroke-linejoin="round"
                    stroke-opacity="1" stroke-width="2"/>
            </svg>
            <span :style="[listStatus.checkedIn ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Checked In</span>
          </li>


          <li :style="[listStatus.nonResponsive ? {borderColor: '#431288 !important'} : {borderColor: '#FFF'}]"
              class="d-inline-block"
              @click="[makeActive('nonResponsive')]">
            <svg fill="none" height="15" viewBox="0 0 23 23" width="15" xmlns="http://www.w3.org/2000/svg">
              <path :stroke="listStatus.nonResponsive  ? '#431288' : '#2B1C1C'"
                    d="M19.6667 1H3.33333C2.04467 1 1 2.04467 1 3.33333V19.6667C1 20.9553 2.04467 22 3.33333 22H19.6667C20.9553 22 22 20.9553 22 19.6667V3.33333C22 2.04467 20.9553 1 19.6667 1Z"
                    stroke-linecap="round"
                    stroke-linejoin="round" stroke-opacity="1" stroke-width="2"/>
              <path :stroke="listStatus.nonResponsive  ? '#431288' : '#2B1C1C'" d="M8 8L15 15"
                    stroke-linecap="round" stroke-linejoin="round" stroke-opacity="1" stroke-width="2"/>
              <path :stroke="listStatus.nonResponsive  ? '#431288' : '#2B1C1C'" d="M15 8L8 15"
                    stroke-linecap="round" stroke-linejoin="round" stroke-opacity="1" stroke-width="2"/>
            </svg>

            <span :style="[listStatus.nonResponsive ? {color: '#431288',} : {color: '#2B1C1C', borderColor: '#FFF'}]">Non Responsive</span>
          </li>
        </ul>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "DashboardSideMenu",
  methods: {
    makeActive(target) {
      this.setCurrentTableState({key: 'currentList', value: target})
      this.setDisplayList(target)
    },
    ...mapActions([
      'setDisplayList',
      'setCurrentTableState',
    ]),
        },
        computed: {
            ...mapGetters(['listStatus'])
        }
    }
</script>

<style scoped>
    ul {
        height: 480px !important;
    }

    ul > li > svg {
        margin-right: 20px;
    }

    ul > li {
        border-right: #FFF solid 3px;
        transition: all .3s ease;
    }

    ul > li > span {
        font-weight: bold;
        font-size: 0.9rem !important;
    }

    ul > li:hover {
        cursor: pointer;
        border-color: rgba(67, 18, 136, 0.5) !important;
    }
</style>